exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".EmptyDashboard-c169f3db{padding:60px 30px;text-align:center}.cards-667d3f07{max-width:920px;margin:40px auto 120px auto}@media screen and (min-width: 1024px){.cards-667d3f07{display:flex}.cards-667d3f07>*{min-width:0;flex:1 1 0px;margin-right:30px}}.cards-667d3f07>*:last-child{margin-right:0px}.constrainWidth-bdfd0cc5{max-width:641px;margin:0 auto}.help-5f057ec2{color:#5C5C5C}\n", ""]);

// Exports
exports.locals = {
	"EmptyDashboard": "EmptyDashboard-c169f3db",
	"cards": "cards-667d3f07",
	"constrainWidth": "constrainWidth-bdfd0cc5",
	"help": "help-5f057ec2"
};